import { useSearchParams } from "@solidjs/router"
import { accountingNavigationArea } from "./accounting-navigation"
import { useAppNavigate } from "./workspace-route"

/** Shared destinations remember their Settings entry point across refreshes. */
export function settingsEntryPath(path: string) {
  const url = new URL(path, "https://workspace.local")
  if (!url.pathname.startsWith("/settings/")) url.searchParams.set("from", "settings")
  return `${url.pathname}${url.search}${url.hash}`
}

/** Keep the return trail within supporting screens, but not when leaving their area. */
export function useSettingsNavigate() {
  const navigate = useAppNavigate()
  const [query] = useSearchParams()
  return (path: string) => navigate(query.from === "settings" && accountingNavigationArea(new URL(path, "https://workspace.local").pathname) === "/settings"
    ? settingsEntryPath(path) : path)
}
